export const listSources = function (sourceNameFilter) {
  return function(input) {
    if (!input || input.length === 0) return "&mdash;";
    if (input.length > 1) return 'Mixed';
    return sourceNameFilter(input[0]);
  };
};

listSources.$inject = ['sourceNameFilter'];
